/*
 * Module for handling the list of action groups
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/selectableList/selectableListModule",
], function (Marionette, Messenger, SelectableListModule) {
  var ActionGroupListController = SelectableListModule.extend({
    /*
     * Overwrite default function to allow a save check before selections
     */
    selectItem: function (clickedModel) {
      //do not try to save if we are already in a save
      if (this.selectedModel !== null && !Messenger.inSave) {
        Messenger.save(function (success) {
          if (success) {
            this._selectItem(clickedModel);
          }
        }, this);
      } else {
        this._selectItem(clickedModel);
      }
    },
    _selectItem: function (clickedModel) {
      if (this.selectedModel !== null) {
        this._markAsUnselected(); //unselect current item
      }
      this.selectedModel = clickedModel;
      if (this.selectedModel !== null) {
        this._markAsSelected();
        //if the model is removed, then just set this.selectedModel to null
        this.selectedModel.once(
          "remove",
          function () {
            this.selectedModel = null;
          },
          this,
        );
        Messenger.vent.trigger("action:list:item:selected", clickedModel);
      }
    },
  });

  return ActionGroupListController;
});
